<h1 class="stock-title">Demo Stock - Stock Replenishment</h1>

<app-breadcrumb></app-breadcrumb>

<br />
<div class="mt-3"></div>
<br />

<div class="align_filters">
<app-demo-stock-filters
  (filtersChanged)="onFiltersChanged($event)"
></app-demo-stock-filters>
</div>

<br />
<div class="mt-3"></div>
<br />
